/*
 * @Author: wangshengqiang
 * @Date: 2021-04-27 18:01:45
 * @LastEditTime: 2021-04-27 18:03:33
 * @LastEditors: wangshengqiang
 * @Description: 缴费频率
 */
import React from 'react';
import RowSelect from '../RowSelect';

const PaymentFrequency = props => {
  return /*#__PURE__*/React.createElement(RowSelect, props);
};

export default PaymentFrequency;